<template>
    <div>
        <el-form ref="form" :model="form" :rules='rules' label-width="220px" class="form">
            <el-card class="box-card" style="margin-bottom: 10px;">
                <div slot="header" class="clearfix">
                    <span>执法检查基本信息</span>
                </div>
                <div class="left-complain-con">
                    <el-row>
                        <el-col :span="8">
                        <el-form-item label="配置编号：" prop='code'>
                            {{form.code}}
                        </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                        <el-form-item label="配置生效起止时间：" prop='date'>
                            {{form.date}}
                        </el-form-item>
                        </el-col>
                        <el-col :span="8">
                        <el-form-item label="请选择执法检查年份" prop='year'>
                            {{form.year}}
                        </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                            <el-form-item label="执法检查类型" prop='type'>
                                {{form.type}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="检查内容适用部门" prop='department'>
                                {{form.department}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            <el-card class="box-card" style="margin-bottom: 10px;">
                <div slot="header" class="clearfix">
                    <span>执法检查内容配置</span>
                </div>
                <div class="left-complain-con">
                    <div class="leftTree">
                        <el-tree
                                :data="treeData"
                                node-key="id"
                                ref="tree"
                                empty-text="暂无数据"
                                :props="cusProps"
                                default-expand-all
                                :highlight-current="true"
                                @node-click="handleTreeNodeClick"
                                :expand-on-click-node="true">
                                <span class="custom-tree-node" slot-scope="{ node }">
                                    <span >{{ node.label }}</span>
                                </span>
                        </el-tree>
                    </div>
                    <div class="rightTable" :class="{'openRightTable':addNodeFlag}">
                        <el-table :data="tableData"
                                class="table-content"
                                v-loading="dataListLoading"
                                style="margin-top: 16px"
                                :row-key="getRowKeys"
                                :height="tableMaxHeight"
                                :header-cell-style="this.$globalGrayTableHeaderStyle"
                                ref="multipleTable"
                                stripe border>
                            <el-table-column label="检查内容ID" prop='code' align="center"
                                            width="220px"
                                            :show-overflow-tooltip='true'>
                            </el-table-column>
                            <el-table-column label="检查内容" prop='content' align="left"
                                            :show-overflow-tooltip='true'>
                            </el-table-column>
                            <el-table-column label="状态" prop='status' align="center"
                                            width="70px"
                                            :show-overflow-tooltip='true'>
                                            <template slot-scope="scope">
                                                {{scope.row.status==1?'有效':'作废'}}
                                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card" style="margin-bottom: 10px;">
                <div slot="header" class="clearfix">
                    <span>抽取频次限制/回避规则</span>
                </div>
                <div class="left-complain-con">
                    <el-row>
                        <el-col :span="20">
                            <el-form-item label="抽取频次限制：" prop='code' >
                                <div class="rowsCount">
                                    <el-switch v-model="form.flag" active-color="#1890ff" inactive-color="#eef1f8" disabled></el-switch>
                                    <span>每位批执法检查人员</span>
                                    <el-input-number v-model="form.num" controls-position="right" @change="handleChange" disabled :min="1" :max="10"></el-input-number>
                                    <span>内只能被抽取到一次</span>
                                </div>
                                <div class="rowsCount">
                                    <el-switch v-model="form.flag" active-color="#1890ff" inactive-color="#eef1f8" disabled></el-switch>
                                    <span>每位评标专家</span>
                                    <el-input-number v-model="form.num" controls-position="right" @change="handleChange" disabled :min="1" :max="10"></el-input-number>
                                    <span>内只能被抽取到一次</span>
                                </div>
                                <div class="rowsCount">
                                    <el-switch v-model="form.flag" active-color="#1890ff" disabled inactive-color="#eef1f8"></el-switch>
                                    <span>每个项目</span>
                                    <el-input-number v-model="form.num" controls-position="right" @change="handleChange" disabled :min="1" :max="10"></el-input-number>
                                    <span>内只能被抽取到一次(相同的监督检查部门)</span>
                                </div>
                                <div class="rowsCount">
                                    <el-switch v-model="form.flag" active-color="#1890ff" disabled inactive-color="#eef1f8"></el-switch>
                                    <span>每个项目</span>
                                    <el-input-number v-model="form.num" controls-position="right" disabled @change="handleChange" :min="1" :max="10"></el-input-number>
                                    <span>内只能被抽取到一次(不同的监督检查部门)</span>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="22">
                            <el-form-item label="交叉回避规则：" prop='date'>
                                <div class="rowsCount">
                                    <el-switch v-model="form.flag" active-color="#1890ff" disabled inactive-color="#eef1f8"></el-switch>
                                    <span style="width:235px">执法检查人员的回避单位与项目的</span>
                                    <el-checkbox-group v-model="form.checkList" disabled>
                                        <el-checkbox label="招标人"></el-checkbox>
                                        <el-checkbox label="招标代理"></el-checkbox>
                                        <el-checkbox label="投标人"></el-checkbox>
                                        <el-checkbox label="中标人"></el-checkbox>
                                        <el-checkbox label="评标专家"></el-checkbox>
                                    </el-checkbox-group>
                                    <span>有交叉时，执法检查人员将不能选取（抽取）到</span>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </el-form>
    </div>
</template>

<script>
    import Sortable from "sortablejs";
    export default {
    data(){
        return{
            form:{
                code:'123',
                date:'2012-02-20',
                type:'2',
                year:'2021',
                department:'财务部',
                num:1,
                flag:false,
                checkList:[],
            },
            rules:{
                date: [
                    {required: true, message: '请选择配置生效起止时间', trigger: ['blur','change']}
                ],
                year: [
                    {required: true, message: '请选择执法检查年份', trigger: ['blur','change']}
                ],
                type: [
                    {required: true, message: '请选择执法检查类型', trigger: ['blur','change']}
                ],
                department: [
                    {required: true, message: '请选择检查内容适用部门', trigger: ['blur','change']}
                ],
            },
            typeOptions:[{}],
            addNodeFlag:false,
            treeData:[],
            cusProps:{
                children:'children',
                label:'label',
            },
            textName:'',
            tableData:[],
            dataListLoading: false,
            tableMaxHeight: document.documentElement.clientHeight - 460 ,
            dialogVisible:false,
            formMin:{
                code:'',
                content:'',
                status:'1'
            },
            rulesMin:{
                code: [
                    {required: true, message: '请输入检查内容ID', trigger: 'blur'}
                ],
                content: [
                    {required: true, message: '请输入检查内容', trigger: 'blur'}
                ],
                status:[
                    {required: true, message: '请选择状态', trigger: ['blur','change']}
                ],
            }
        }
    },
    activated(){
        this.getData();
    },
    methods:{
        getRowKeys(row) {
            return row.id
        },
        getData(){
            this.treeData =[
                {
                    id:'1',
                    label: "全部检查对象",
                    level: 1,
                    children:[
                        {
                            id:'11',
                            hover:false,
                            label: "招标人",
                            level: 2,
                        },
                        {
                            id:'12',
                            hover:false,
                            label: "投标人",
                            level: 2,
                        },
                        {
                            id:'13',
                            hover:false,
                            label: "监督部门",
                            level: 2,
                        }
                    ],
                }
            ];
            this.tableData=[
                {id:'1111',code:'ZFJC2021010001',content:'是否具有编制招标文件和组织评标的能力，内部管理制度是否健全',status:1},
                {id:'2222',code:'ZFJC2021010002',content:'是否使用国家有关行政监督部门制定的标准文本，是否存在设置不合理的条件限制、排斥潜在投标人，或以任何方式规避招标',status:1},
                {id:'3333',code:'ZFJC2021010003',content:'是否存在影响资格预审结果或者潜在投标人投标的内容',status:0}
            ]
        },
        handleChange(){

        },
        handleTreeNodeClick( data){
            if (data.level == 3) {
                console.log('切换数据')
                this.getTableList(data)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .leftTree{
            width:242px;
            float: left;
            margin-bottom: 20px;
            padding: 10px 0px;

            /deep/ .el-button+.el-button{
                margin-left: 4px;
            }

            /deep/ .is-leaf.el-tree-node__expand-icon{
                display: none;
            }

            .addNodeWrapper{
                .el-range-editor.el-input__inner{
                    padding: 3px 0px 3px 8px;
                }
            }



            .pointer{
                display: inline-block;
                width:6px;
                height:6px;
                border-radius: 50%;
                margin:2px 6px;
                background: rgba(0, 0, 0, 0.25);
            }

            .iconImg{
                width: 14px;
            }


            /deep/ .el-tree-node__content {
                /deep/ .el-icon-folder {
                    padding: 0;
                    display: none;
                }
            }

            .el-tree--highlight-current {
                /deep/ .el-tree-node.is-current{
                    >.el-tree-node__content{
                        background-color: rgba(27, 154, 238, 0.1);
                        color:rgba(27, 154, 238, 1);
                    }
                    .pointer{
                        background-color:rgba(27, 154, 238, 1);;
                    }
                }
            }


            .custom-tree-node{
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }

            /deep/ span.is-leaf{
                padding:0 !important;
            }
            .el-input{
                margin-top: 10px;
                width: 150px!important;
            }


        }
        .openLeftTree{
            width:300px;
        }
        .rightTable{
            width: calc(100% - 242px);
            float: right;padding: 15px;
            border-left: 1px solid #dcdfe6;
            .svg-icon-btn{
                margin-left: 4px;
                &:hover{
                    color:#1890FF;
                }
            }



    }
    /deep/ .el-input,.el-date-editor{
        width: 100%!important;
    }
    .rowsCount{
        height: 50px;
        line-height: 50px;
        span{
            display:inline-block;
            &:nth-of-type(1){
                width: 150px;
                text-align: right;
                margin-right: 15px;
            }
            &:nth-of-type(2){
                width: 350px;
                text-align: left;
                margin-left: 15px;
            }
            
        }
        /deep/ .el-checkbox-group{
            display:inline-block;
        }
        .el-checkbox{
            margin-left: 0;
        }
    }
</style>